<template>
  <div id="CheckParsing" v-if="bankdata">
    <div class="topic_title">{{bankdata.order}}.( {{typetext}} ){{bankdata.questionTitle}}</div>
    <div class="topic_box">
      <el-checkbox-group disabled v-model="radio"  @change="getVal" >
        <p :key="index" class="option" v-for="(item, index) in listData.questionSelect">
          <el-checkbox :label="item.value"     >{{item.lable}}</el-checkbox>
        </p>
      </el-checkbox-group>
    </div>
    <div class="el-Parsing">
      <div class="title">
        <div class="title_item">
          参考答案：
          <span class="blue">{{bankdata.questionAnswer | check_text}}</span>
        </div>
        <div class="title_item">
          你的答案：
          <span class="red">{{bankdata.select | check}}</span>
        </div>
      </div>
      <div class="content" v-if="bankdata.questionDescribe">答案解析：{{bankdata.questionDescribe}}</div>
      <div class="content" v-else>答案解析：解析正在更新中...</div>
    </div>
  </div>
</template>
<script>
module.exports = {
  name: 'check-parsing',
  props: ['bankdata', 'typetext'],
  data () {
    return {
      radio: [],
      listData: '',
      img_url: ''
    }
  },
  mounted () {
    if (this.bankdata) {
             console.log(this.bankdata.questionSelect,'6666') 
      this.initFn()
    }
  },
  watch: {
    bankdata () {
      this.radio = []
      this.initFn()
    }
  },
  filters: {
    check (val) {
      if (val.indexOf('[') > -1) {
        return ''
      } else if (val.indexOf('###') > -1) {
        return val.replace(/###/g, '、')
      } else {
        return val
      }
    },
    check_text (val) {
      if (val.indexOf('###') > -1) {
        return val.replace(/###/g, '、')
      } else {
        return val
      }
    }
  },
  computed: {
  },
  methods: {
    redios (val) {
         const array = []
      if (val.length  > 1) {
        if( val.indexOf('###') > -1 ) {
          const split= val.split('###') 
          return split
        }else{
          for(let i = 0 ; i<val.length ;i ++){
           array .push(val[i])
          }
        return array
        }
      } else{
        array .push(val)
        return array
      }
    },
   getVal(){

     console.log('redio',this.radio)
   },

    initFn () {
    let arr = this.bankdata.questionSelect
    if (!(arr instanceof Array)) {
      arr = arr.split('###')
      let obj = []
      for (let i = 0; i < arr.length; i++) {
        obj[i] = {}
        obj[i].lable = arr[i]
        obj[i].value = arr[i].substring(0, 1) 
      }

      this.bankdata.questionSelect = obj
    }
    this.listData = this.bankdata
    this.radio =  this.redios(this.bankdata.select)


    }
  }
}
</script>
